import { render, staticRenderFns } from "./version-label.vue?vue&type=template&id=5535405e&scoped=true&"
import script from "./version-label.vue?vue&type=script&lang=ts&"
export * from "./version-label.vue?vue&type=script&lang=ts&"
import style0 from "./version-label.vue?vue&type=style&index=0&id=5535405e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535405e",
  null
  
)

export default component.exports